<script>
  // Перенос Panel из lib/ui.tsx — тёмная карточка-контейнер.
  export let pad = true;
  export let flat = false;
  let className = '';
  export { className as class };
  export let style = undefined;
</script>

<div class={'ui-panel' + (pad ? ' pad' : '') + (flat ? ' flat' : '') + (className ? ' ' + className : '')} {style} on:click>
  <slot />
</div>
